import {
  StonjiWhiteHeartIllustration_default
} from "./chunk-G3VNRJ3V.mjs";
import {
  StonjiWithoutAsteriscGreenIllustration_default
} from "./chunk-6QCYPAMD.mjs";
import {
  StonjiWithoutAsteriscIllustration_default
} from "./chunk-3RJ3XAG7.mjs";
import {
  TabletIllustration_default
} from "./chunk-GPYFGH7D.mjs";
import {
  TonLogoIllustration_default
} from "./chunk-UBC7DJ7E.mjs";
import {
  TonLogoMobileIllustration_default
} from "./chunk-F52PCQLG.mjs";
import {
  StonjiPillarAppIllustration_default
} from "./chunk-GYODQ53W.mjs";
import {
  StonjiPillarCallIllustration_default
} from "./chunk-CUSW2QZK.mjs";
import {
  StonjiPillarIntegrationsIllustration_default
} from "./chunk-PH54PLGM.mjs";
import {
  StonjiPillarJustIllustration_default
} from "./chunk-UWUUM74F.mjs";
import {
  StonjiPixIllustration_default
} from "./chunk-XUBYN735.mjs";
import {
  StonjiShieldIllustration_default
} from "./chunk-BG7Y54QT.mjs";
import {
  StonjiSmileIllustration_default
} from "./chunk-BL5EVVZZ.mjs";
import {
  StonjiWheelIllustration_default
} from "./chunk-JGWRFKBZ.mjs";
import {
  StonjiMoneyGreenIllustration_default
} from "./chunk-STHNB37S.mjs";
import {
  StonjiMoneyIllustration_default
} from "./chunk-YBXXAGTD.mjs";
import {
  StonjiPackageIllustration_default
} from "./chunk-K5E2GD6X.mjs";
import {
  StonjiPercentBlack_default
} from "./chunk-NW2NUFTF.mjs";
import {
  StonjiPercentGreenIllustration_default
} from "./chunk-XIIORMLD.mjs";
import {
  StonjiPercentIllustration_default
} from "./chunk-GR5TR2XR.mjs";
import {
  StonjiPhoneGreenIllustration_default
} from "./chunk-PSTNZZLV.mjs";
import {
  StonjiPhoneIllustration_default
} from "./chunk-NAMQQVFA.mjs";
import {
  StonjiCheckGreenIllustration_default
} from "./chunk-Y4VDASDH.mjs";
import {
  StonjiCheckIllustration_default
} from "./chunk-C3SUN5K3.mjs";
import {
  StonjiCreditCardFrontIllustration_default
} from "./chunk-LYB644CG.mjs";
import {
  StonjiCreditCardIllustration_default
} from "./chunk-6Q636JLQ.mjs";
import {
  StonjiDollarSignIllustration_default
} from "./chunk-FV2B2JGS.mjs";
import {
  StonjiFaceIllustration_default
} from "./chunk-AXMC5CQO.mjs";
import {
  StonjiLockIllustration_default
} from "./chunk-TGGKEVNN.mjs";
import {
  StonjiMoneyBlackIllustration_default
} from "./chunk-4Y7XDXY2.mjs";
import {
  StoneLogoMobileIllustration_default
} from "./chunk-K37O2JYH.mjs";
import {
  StonjiAgentIllustration_default
} from "./chunk-C7CUVCF4.mjs";
import {
  StonjiArrowUpIllustration_default
} from "./chunk-W3IWGNN5.mjs";
import {
  StonjiBarsIllustration_default
} from "./chunk-IHA5XYJG.mjs";
import {
  StonjiBoletoIllustration_default
} from "./chunk-ZWL7PH3B.mjs";
import {
  StonjiCardErrorIllustration_default
} from "./chunk-3AJIHBXG.mjs";
import {
  StonjiChartBlackIllustration_default
} from "./chunk-O64RHERA.mjs";
import {
  StonjiChatIllustration_default
} from "./chunk-6H33QZOH.mjs";
import {
  PixInLoteIllustration_default
} from "./chunk-PJURSAAE.mjs";
import {
  PosNfcIllustration_default
} from "./chunk-VATKQ7PF.mjs";
import {
  QrCodeSquareIllustration_default
} from "./chunk-EDQHAADY.mjs";
import {
  ShieldIllustration_default
} from "./chunk-4WFYZMHR.mjs";
import {
  SoftwaresIllustration_default
} from "./chunk-VPHWYZPN.mjs";
import {
  StoneCardGrayIllustration_default
} from "./chunk-HVXB5Q4G.mjs";
import {
  StoneCardIllustration_default
} from "./chunk-FSLRPZUW.mjs";
import {
  StoneLogoIllustration_default
} from "./chunk-ISGXSW56.mjs";
import {
  LinxLogoIllustration_default
} from "./chunk-TN6BYJF5.mjs";
import {
  LinxLogoMobileIllustration_default
} from "./chunk-5FVRIIZK.mjs";
import {
  MachinePosIllustration_default
} from "./chunk-Y2PT6TMC.mjs";
import {
  MachineTabletIllustration_default
} from "./chunk-6YSCIOY6.mjs";
import {
  MailSuccessesIllustration_default
} from "./chunk-NICBLKOV.mjs";
import {
  PackageIllustration_default
} from "./chunk-MFKJLSMR.mjs";
import {
  PercentGreenIllustration_default
} from "./chunk-ZI42GLUM.mjs";
import {
  PhoneIllustration_default
} from "./chunk-ANQXILML.mjs";
import {
  HandCardMachineIllustration_default
} from "./chunk-VBH73XPI.mjs";
import {
  HandQrCodeIllustration_default
} from "./chunk-AYT2DZ35.mjs";
import {
  HandsUsingAppGray_default
} from "./chunk-GKHBW7OG.mjs";
import {
  HandsUsingAppIllustration_default
} from "./chunk-IMT5VCKK.mjs";
import {
  HangLooseIllustration_default
} from "./chunk-CDVW3JKL.mjs";
import {
  HeadPhoneSoftIllustration_default
} from "./chunk-ZIX3G675.mjs";
import {
  IntegrationsIllustration_default
} from "./chunk-5AK6ITQU.mjs";
import {
  JustStonjiIllustration_default
} from "./chunk-Y6R5A54U.mjs";
import {
  DeliveryIllustration_default
} from "./chunk-VL3GUXUW.mjs";
import {
  DoubleCardsIllustration_default
} from "./chunk-Z7XLHN2K.mjs";
import {
  EasyTurningGrayIllustration_default
} from "./chunk-NGJAC5DN.mjs";
import {
  EasyTurningIllustration_default
} from "./chunk-5XEGOIMM.mjs";
import {
  FoneIllustration_default
} from "./chunk-YLGUKOV2.mjs";
import {
  FreeMachineIllustration_default
} from "./chunk-WTFIXJRI.mjs";
import {
  Gift2XIllustration_default
} from "./chunk-NLGZ2LMT.mjs";
import {
  GreenCheckIllustration_default
} from "./chunk-XJNPIMMF.mjs";
import {
  CallIllustration_default
} from "./chunk-NRIZLK7Q.mjs";
import {
  CardErrorIllustration_default
} from "./chunk-ET2FKR2D.mjs";
import {
  CoinGrayIllustration_default
} from "./chunk-PYYSLQ53.mjs";
import {
  CoinIllustration_default
} from "./chunk-IKKTYNEF.mjs";
import {
  CoinStackIllustration_default
} from "./chunk-7Z2J5HSO.mjs";
import {
  CoinsIllustration_default
} from "./chunk-H27W72IW.mjs";
import {
  CoinsStackShineIllustration_default
} from "./chunk-2NJ6O2W5.mjs";
import {
  CreditCardIllustration_default
} from "./chunk-3B3SP7FH.mjs";
import {
  AnimationChatIllustration_default
} from "./chunk-346L6VMN.mjs";
import {
  AnimationPhoneIllustration_default
} from "./chunk-UHM3KRKF.mjs";
import {
  AnimationWhatsappIllustration_default
} from "./chunk-FNESQTA7.mjs";
import {
  AppIllustration_default
} from "./chunk-BVPJ2ZDW.mjs";
import {
  BlackCheckIllustration_default
} from "./chunk-TZSTZCX3.mjs";
import {
  BlackQrCodeIllustration_default
} from "./chunk-E6TCLJCC.mjs";
import {
  BoletoIllustration_default
} from "./chunk-CWBHRZSM.mjs";
import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/stone/illustrations/index.ts
var illustrations_exports = {};
__export(illustrations_exports, {
  animationChat: () => AnimationChatIllustration_default,
  animationPhone: () => AnimationPhoneIllustration_default,
  animationWhatsapp: () => AnimationWhatsappIllustration_default,
  app: () => AppIllustration_default,
  blackCheck: () => BlackCheckIllustration_default,
  blackQrCode: () => BlackQrCodeIllustration_default,
  boleto: () => BoletoIllustration_default,
  call: () => CallIllustration_default,
  cardError: () => CardErrorIllustration_default,
  coin: () => CoinIllustration_default,
  coinGray: () => CoinGrayIllustration_default,
  coinStack: () => CoinStackIllustration_default,
  coins: () => CoinsIllustration_default,
  coinsStackShine: () => CoinsStackShineIllustration_default,
  creditCard: () => CreditCardIllustration_default,
  delivery: () => DeliveryIllustration_default,
  doubleCards: () => DoubleCardsIllustration_default,
  easyTurning: () => EasyTurningIllustration_default,
  easyTurningGray: () => EasyTurningGrayIllustration_default,
  fone: () => FoneIllustration_default,
  freeMachine: () => FreeMachineIllustration_default,
  gift2X: () => Gift2XIllustration_default,
  greenCheck: () => GreenCheckIllustration_default,
  handCardMachine: () => HandCardMachineIllustration_default,
  handQrCode: () => HandQrCodeIllustration_default,
  handsUsingApp: () => HandsUsingAppIllustration_default,
  handsUsingAppGray: () => HandsUsingAppGray_default,
  hangLoose: () => HangLooseIllustration_default,
  headPhoneSoft: () => HeadPhoneSoftIllustration_default,
  integrations: () => IntegrationsIllustration_default,
  justStonji: () => JustStonjiIllustration_default,
  linxLogo: () => LinxLogoIllustration_default,
  linxLogoMobile: () => LinxLogoMobileIllustration_default,
  machinePos: () => MachinePosIllustration_default,
  machineTablet: () => MachineTabletIllustration_default,
  mailSuccesses: () => MailSuccessesIllustration_default,
  package: () => PackageIllustration_default,
  percentGreen: () => PercentGreenIllustration_default,
  phone: () => PhoneIllustration_default,
  pixInLote: () => PixInLoteIllustration_default,
  posNfc: () => PosNfcIllustration_default,
  qrCodeSquare: () => QrCodeSquareIllustration_default,
  shield: () => ShieldIllustration_default,
  softwares: () => SoftwaresIllustration_default,
  stoneCard: () => StoneCardIllustration_default,
  stoneCardGray: () => StoneCardGrayIllustration_default,
  stoneLogo: () => StoneLogoIllustration_default,
  stoneLogoMobile: () => StoneLogoMobileIllustration_default,
  stonjiAgent: () => StonjiAgentIllustration_default,
  stonjiArrowUp: () => StonjiArrowUpIllustration_default,
  stonjiBars: () => StonjiBarsIllustration_default,
  stonjiBoleto: () => StonjiBoletoIllustration_default,
  stonjiCardError: () => StonjiCardErrorIllustration_default,
  stonjiChartBlack: () => StonjiChartBlackIllustration_default,
  stonjiChat: () => StonjiChatIllustration_default,
  stonjiCheck: () => StonjiCheckIllustration_default,
  stonjiCheckGreen: () => StonjiCheckGreenIllustration_default,
  stonjiCreditCard: () => StonjiCreditCardIllustration_default,
  stonjiCreditCardFront: () => StonjiCreditCardFrontIllustration_default,
  stonjiDollarSign: () => StonjiDollarSignIllustration_default,
  stonjiFace: () => StonjiFaceIllustration_default,
  stonjiLock: () => StonjiLockIllustration_default,
  stonjiMoney: () => StonjiMoneyIllustration_default,
  stonjiMoneyBlack: () => StonjiMoneyBlackIllustration_default,
  stonjiMoneyGreen: () => StonjiMoneyGreenIllustration_default,
  stonjiPackage: () => StonjiPackageIllustration_default,
  stonjiPercent: () => StonjiPercentIllustration_default,
  stonjiPercentBlack: () => StonjiPercentBlack_default,
  stonjiPercentGreen: () => StonjiPercentGreenIllustration_default,
  stonjiPhone: () => StonjiPhoneIllustration_default,
  stonjiPhoneGreen: () => StonjiPhoneGreenIllustration_default,
  stonjiPillarApp: () => StonjiPillarAppIllustration_default,
  stonjiPillarCall: () => StonjiPillarCallIllustration_default,
  stonjiPillarIntegrations: () => StonjiPillarIntegrationsIllustration_default,
  stonjiPillarJust: () => StonjiPillarJustIllustration_default,
  stonjiPix: () => StonjiPixIllustration_default,
  stonjiShield: () => StonjiShieldIllustration_default,
  stonjiSmile: () => StonjiSmileIllustration_default,
  stonjiWheel: () => StonjiWheelIllustration_default,
  stonjiWhiteHeart: () => StonjiWhiteHeartIllustration_default,
  stonjiWithoutAsterisc: () => StonjiWithoutAsteriscIllustration_default,
  stonjiWithoutAsteriscGreen: () => StonjiWithoutAsteriscGreenIllustration_default,
  tablet: () => TabletIllustration_default,
  tonLogo: () => TonLogoIllustration_default,
  tonLogoMobile: () => TonLogoMobileIllustration_default
});

export {
  illustrations_exports
};
